module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/productos/productos-buscados/filter/productos-buscados-filter/productos-buscados-filter.component.scss
// module id = ./src/app/productos/productos-buscados/filter/productos-buscados-filter/productos-buscados-filter.component.scss
// module chunks = main